import * as React from 'react';
import { useSelector } from 'react-redux';

import { AgentsOffersRow } from '../../components/AgentsOffersRow';
import { OffersFooter } from '../../components/OffersFooter';
import { OffersList, OffersRow } from '../../components/OffersList';
import { FlatsError } from '../../components/FlatsError';
import { getIsCPL, getNewbuildingBrokerBookingAvailable, getNewbuildingId } from '../../selectors/newbuilding';
import { getSelectedHouseId, getSelectedHouseOffers, isHouseNameVisible } from '../../selectors/offers';
import { OffersKPNRowContainer } from '../OffersKPNRow';
import { OffersBannerContainer } from '../OffersBannerContainer';
import {
  trackAgentFlatsLinkClick,
  trackAllFlatsLinkClick,
  trackOffersQuantityLinkClick,
  trackOpenFlat,
  trackRoomTypeLinkClick,
  trackServiceBannerClickChange,
} from './tracking';
import { getFlatsErrorTitle } from './utils/getFlatsErrorTitle';

export function OffersContainer() {
  const offers = useSelector(getSelectedHouseOffers);
  const displayHouseName = useSelector(isHouseNameVisible);
  const selectedHouseId = useSelector(getSelectedHouseId);
  const newbuildingId = useSelector(getNewbuildingId);
  const isCPL = useSelector(getIsCPL);
  const isBrokerBookingAvailable = useSelector(getNewbuildingBrokerBookingAvailable);
  const isOffersBannerVisible = isCPL && isBrokerBookingAvailable;

  const onSellersInfoClick = React.useCallback(() => {
    trackServiceBannerClickChange(newbuildingId);
  }, [newbuildingId]);

  const onOffersQuantityLinkClick = React.useCallback((roomType: string) => {
    trackOffersQuantityLinkClick(newbuildingId, roomType);
  }, []);

  if (!offers) {
    return null;
  }

  const { fromAgentsPropsCountDisplay, fromAgentsPropsCountUrl, propsCountDisplay, propsCountUrl, fromDeveloperRooms } =
    offers;

  if (fromDeveloperRooms && fromDeveloperRooms.length > 0) {
    return (
      <div data-testid="offers-stats">
        <OffersList>
          {fromDeveloperRooms.map(flatTypeBlock => (
            <OffersRow
              key={flatTypeBlock.roomTypeDisplay}
              {...flatTypeBlock}
              displayHouseName={displayHouseName}
              onRoomTypeLinkClick={trackRoomTypeLinkClick}
              onOfferLinkClick={trackOpenFlat}
              onOffersQuantityLinkClick={onOffersQuantityLinkClick}
            />
          ))}
        </OffersList>
        {isOffersBannerVisible && <OffersBannerContainer />}
        {!isCPL && <OffersKPNRowContainer title="Подберите квартиру в этом или похожих ЖК" />}
        <OffersFooter
          fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={fromAgentsPropsCountUrl}
          propsCountDisplay={propsCountDisplay as string}
          propsCountUrl={propsCountUrl as string}
          isHouseSelected={!!selectedHouseId}
          onAgentOffersLinkClick={trackAgentFlatsLinkClick}
          onAllOffersLinkClick={trackAllFlatsLinkClick}
          onSellersInfoClick={onSellersInfoClick}
        />
      </div>
    );
  }

  return (
    <>
      {isCPL ? (
        <FlatsError
          image="not-found"
          title={getFlatsErrorTitle(!!fromAgentsPropsCountDisplay, !!selectedHouseId)}
          text={selectedHouseId ? 'Выберите другой корпус или уточните информацию у застройщика' : null}
        />
      ) : (
        <OffersKPNRowContainer
          title={<span>Нет предложений от застройщика. Мы подберём квартиры в&nbsp;похожих&nbsp;ЖК</span>}
          withMarginTop
        />
      )}
      {fromAgentsPropsCountDisplay && (
        <AgentsOffersRow
          fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={fromAgentsPropsCountUrl as string}
        />
      )}
    </>
  );
}
